export const theme = {
  colors: {
    // 🍂 TURUNCU-KAHVERENGİ RENK PALETİ
    primary: '#D97706', // Warm Orange - Ana renk
    secondary: '#92400E', // Deep Brown - Kahverengi
    accent: '#F59E0B', // Bright Amber - Vurgu
    tertiary: '#A3A3A3', // Warm Gray - Nötr
    quaternary: '#059669', // Forest Green - Doğal
    
    // 🌟 SICAK ARKA PLAN SİSTEMİ
    background: 'linear-gradient(135deg, #451A03 0%, #78350F 25%, #92400E 50%, #A16207 75%, #CA8A04 100%)',
    surface: 'rgba(255, 255, 255, 0.08)',
    surfaceHover: 'rgba(255, 255, 255, 0.12)',
    
    // 📝 METİN RENKLERİ
    text: {
      primary: '#FFFFFF', // Pure White - Maksimum kontrast
      secondary: 'rgba(255, 255, 255, 0.9)', // Güçlü beyaz
      light: 'rgba(255, 255, 255, 0.8)', // Orta şeffaflık
      white: '#FFFFFF',
      glow: '#F59E0B' // Amber Glow
    },
    
    // 🔲 BORDER VE ÇERÇEVELER
    border: 'rgba(254, 252, 232, 0.2)',
    borderLight: 'rgba(254, 252, 232, 0.1)',
    borderGlow: 'rgba(217, 119, 6, 0.4)',
    
    // ✅ DURUM RENKLERİ
    success: '#059669', // Forest Green
    warning: '#F59E0B', // Amber
    error: '#DC2626', // Red
    orange: '#EA580C', // Vibrant Orange
    lightOrange: 'rgba(234, 88, 12, 0.1)',
    
    // 🎨 SICAK GRADİENTLER
    gradient: {
      primary: 'linear-gradient(135deg, #D97706 0%, #92400E 50%, #78350F 100%)',
      secondary: 'linear-gradient(135deg, #F59E0B 0%, #D97706 50%, #92400E 100%)',
      accent: 'linear-gradient(135deg, #FBBF24 0%, #F59E0B 50%, #D97706 100%)',
      warm: 'linear-gradient(135deg, #FED7AA 0%, #FB923C 50%, #EA580C 100%)',
      cool: 'linear-gradient(135deg, #78350F 0%, #92400E 100%)',
      elegant: 'linear-gradient(135deg, #451A03 0%, #78350F 50%, #92400E 100%)',
      luxury: 'linear-gradient(135deg, #451A03 0%, #78350F 25%, #D97706 100%)',
      sophisticated: 'linear-gradient(135deg, #92400E 0%, #D97706 25%, #451A03 100%)'
    },
    
    // 💎 SICAK CAM EFEKTLERİ
    glass: {
      background: 'rgba(69, 26, 3, 0.7)',
      backgroundHover: 'rgba(69, 26, 3, 0.8)',
      border: 'rgba(254, 252, 232, 0.12)',
      borderGlow: 'rgba(217, 119, 6, 0.3)',
      backdrop: 'blur(24px)',
      shadow: '0 25px 50px -12px rgba(69, 26, 3, 0.6)'
    },
    
    // ⚡ SICAK ACCENT RENKLERİ
    accentColors: {
      orange: '#D97706',
      brown: '#92400E', 
      amber: '#F59E0B',
      gold: '#FBBF24',
      copper: '#EA580C',
      rust: '#DC2626'
    },
    
    // 🌟 SICAK PARÇACIK EFEKTLERİ
    particles: {
      primary: 'rgba(217, 119, 6, 0.6)',
      secondary: 'rgba(146, 64, 14, 0.4)',
      accent: 'rgba(245, 158, 11, 0.5)'
    }
  },
  fonts: {
    primary: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    secondary: '"Playfair Display", serif'
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem'
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem'
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem'
  },
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1)'
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
  }
};
